import { FlowContext } from '../types';

export const shouldSkipWhenUserIsLoggedIn = (context: FlowContext): boolean => {
  const { isAuthenticated } = context;
  return !!isAuthenticated;
};
